import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Resources = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const carouselItems = [
    {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=1200&h=600&fit=crop",
      title: "DI-KISS Masterclass Tutorials",
      subtitle: "Expert-Led Training Programs",
      description: "Access comprehensive training modules covering all aspects of successful campaigning from leading political strategists.",
      cta: "Access Masterclasses"
    },
    {
      image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=1200&h=600&fit=crop",
      title: "10 Keys to Victory™ Resources",
      subtitle: "Strategic Campaign Materials",
      description: "Download exclusive campaign playbooks, templates, and strategic guides used by successful political campaigns.",
      cta: "Browse Resources"
    },
    {
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=600&fit=crop",
      title: "Strategy Research Library",
      subtitle: "Evidence-Based Campaign Intelligence",
      description: "Access proprietary research, polling data, and strategic analysis from KISS's comprehensive campaign studies.",
      cta: "Explore Research"
    }
  ];

  useEffect(() => {
    if (!isHovered) {
      const timer = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
      }, 6000);
      return () => clearInterval(timer);
    }
  }, [isHovered, carouselItems.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselItems.length) % carouselItems.length);
  };

  const resources = [
    {
      id: 1,
      title: "How to Devise a Winning Campaign Strategy",
      description: "Master the fundamentals of strategic campaign planning and execution",
      category: "masterclasses",
      type: "Video + PDF",
      size: "150 min",
      downloadUrl: "#",
      featured: true
    },
    {
      id: 2,
      title: "How to Organise Your Campaign Effectively",
      description: "Build a high-performing campaign organization structure",
      category: "masterclasses",
      type: "Video + PDF",
      size: "120 min",
      downloadUrl: "#",
      featured: true
    },
    {
      id: 3,
      title: "How to Create Powerful and Persuasive Campaign Advertising",
      description: "Craft compelling advertising that resonates with Kenyan voters",
      category: "masterclasses",
      type: "Video + PDF",
      size: "180 min",
      downloadUrl: "#",
      featured: true
    },
    {
      id: 4,
      title: "How to Use Domestic Policy to Electoral Advantage",
      description: "Leverage domestic policy issues for electoral success",
      category: "masterclasses",
      type: "Video + PDF",
      size: "135 min",
      downloadUrl: "#",
      featured: false
    },
    {
      id: 5,
      title: "How to Use Foreign Policy to Electoral Advantage",
      description: "Strategic use of foreign policy in domestic electoral politics",
      category: "masterclasses",
      type: "Video + PDF",
      size: "145 min",
      downloadUrl: "#",
      featured: false
    },
    {
      id: 6,
      title: "How to Use Opinion Polls and Focus Groups Strategically",
      description: "Strategic application of research data in campaign decision-making",
      category: "masterclasses",
      type: "Video + PDF",
      size: "160 min",
      downloadUrl: "#",
      featured: false
    },
    {
      id: 7,
      title: "How to Perform Confidently and Effectively in Media Interviews",
      description: "Professional media training for political leaders",
      category: "masterclasses",
      type: "Video + PDF",
      size: "200 min",
      downloadUrl: "#",
      featured: false
    },
    {
      id: 8,
      title: "How to Deliver Impactful and Memorable Speeches",
      description: "Master the art of public speaking and speech delivery",
      category: "masterclasses",
      type: "Video + PDF",
      size: "175 min",
      downloadUrl: "#",
      featured: false
    },
    {
      id: 9,
      title: "How to Survive and Counter Your Opponent's Attacks",
      description: "Strategic defense and counter-attack methodologies",
      category: "masterclasses",
      type: "Video + PDF",
      size: "190 min",
      downloadUrl: "#",
      featured: false
    },
    {
      id: 10,
      title: "How to Identify Your Voters and Get Them to the Polls",
      description: "Advanced voter identification and mobilization strategies",
      category: "masterclasses",
      type: "Video + PDF",
      size: "170 min",
      downloadUrl: "#",
      featured: false
    }
  ];

  const caseStudies = [
    {
      title: "Strategy101 Program Graduate - Presidential Victory",
      description: "Comprehensive application of the 10 Keys to Victory framework led to a decisive presidential election win.",
      outcome: "58% national vote share",
      region: "National Level"
    },
    {
      title: "DI-KISS Masterclass Success - Gubernatorial Win",
      description: "Strategic training in policy development and voter mobilization resulted in a successful gubernatorial campaign.",
      outcome: "52% county vote share",
      region: "County Level"
    },
    {
      title: "10 Keys to Victory Implementation - Parliamentary Success",
      description: "Application of opponent attack survival and GOTV strategies secured a parliamentary seat victory.",
      outcome: "55% constituency vote share",
      region: "Constituency Level"
    }
  ];

  const categories = [
    { id: 'all', label: 'All Resources', count: resources.length },
    { id: 'playbooks', label: 'Campaign Playbooks', count: resources.filter(r => r.category === 'playbooks').length },
    { id: 'guides', label: 'Strategy Guides', count: resources.filter(r => r.category === 'guides').length },
    { id: 'templates', label: 'Templates', count: resources.filter(r => r.category === 'templates').length }
  ];

  const filteredResources = activeCategory === 'all'
    ? resources
    : resources.filter(resource => resource.category === activeCategory);

  const featuredResources = resources.filter(resource => resource.featured);

  return (
    <div>
      {/* Interactive Hero Carousel */}
      <section
        className="relative w-full overflow-hidden rounded-b-2xl shadow-2xl"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {carouselItems.map((item, index) => (
            <div key={index} className="w-full flex-shrink-0">
              <div className="relative h-96 md:h-[500px] bg-gradient-to-br from-secondary-700 to-secondary-900">
                <div className="absolute inset-0 bg-black bg-opacity-40"></div>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center text-white max-w-4xl px-4">
                    <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-2 text-shadow">
                      {item.title}
                    </h1>
                    <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4 text-secondary-200">
                      {item.subtitle}
                    </h2>
                    <p className="text-lg md:text-xl mb-8 text-secondary-100 leading-relaxed">
                      {item.description}
                    </p>
                    <Link
                      to="/contact"
                      className="btn-primary bg-white text-secondary-900 hover:bg-secondary-50 text-lg py-3 px-8 inline-block transform hover:scale-105 transition-all duration-300"
                    >
                      {item.cta}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300 z-10"
          aria-label="Previous slide"
        >
          <i className="bi bi-chevron-left text-xl"></i>
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300 z-10"
          aria-label="Next slide"
        >
          <i className="bi bi-chevron-right text-xl"></i>
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
          {carouselItems.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentSlide
                  ? 'bg-white scale-125'
                  : 'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* Featured Resources */}
      <section className="bg-primary-50 section-padding">
        <div className="container-max">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-secondary-900 mb-3 sm:mb-4">
              10 Keys to Victory Masterclasses
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-secondary-600">
              Comprehensive training modules for electoral success at all levels
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {featuredResources.map((resource) => (
              <div key={resource.id} className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                {/* Resource Image */}
                <div className="w-full h-32 mb-4 rounded-lg overflow-hidden">
                  <img
                    src={
                      resource.title.includes("Winning Campaign Strategy")
                        ? "https://images.unsplash.com/photo-1552664730-d307ca884978?w=300&h=200&fit=crop"
                        : resource.title.includes("Campaign Organization")
                        ? "https://images.unsplash.com/photo-1553484771-047a44eee27b?w=300&h=200&fit=crop"
                        : resource.title.includes("Persuasive Advertising")
                        ? "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=300&h=200&fit=crop"
                        : resource.title.includes("Domestic Policy")
                        ? "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=200&fit=crop"
                        : "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=300&h=200&fit=crop"
                    }
                    alt={resource.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>

                <div className="flex items-center justify-between mb-4">
                  <span className="bg-primary-100 text-primary-800 px-3 py-1 rounded-full text-sm font-semibold">
                    {resource.type}
                  </span>
                  <span className="text-secondary-500 text-sm">{resource.size}</span>
                </div>

                <h3 className="text-xl font-bold text-secondary-900 mb-3">{resource.title}</h3>
                <p className="text-secondary-600 mb-6">{resource.description}</p>

                <button className="btn-primary w-full hover:scale-105 transition-transform duration-200">
                  Access Tutorial
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Resource Categories */}
      <section className="bg-white section-padding">
        <div className="container-max">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-secondary-900 mb-4">
              Campaign Resource Library
            </h2>
            <p className="text-xl text-secondary-600">
              Comprehensive collection of tools, templates, and strategic guides
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-colors duration-200 ${
                  activeCategory === category.id
                    ? 'bg-primary-600 text-white'
                    : 'bg-secondary-100 text-secondary-700 hover:bg-primary-100 hover:text-primary-700'
                }`}
              >
                {category.label} ({category.count})
              </button>
            ))}
          </div>

          {/* Resources Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredResources.map((resource) => (
              <div key={resource.id} className="bg-secondary-50 p-6 rounded-xl hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center justify-between mb-4">
                  <span className="bg-primary-100 text-primary-800 px-3 py-1 rounded-full text-sm font-semibold">
                    {resource.type}
                  </span>
                  <span className="text-secondary-500 text-sm">{resource.size}</span>
                </div>

                <h3 className="text-lg font-bold text-secondary-900 mb-3">{resource.title}</h3>
                <p className="text-secondary-600 mb-6 text-sm">{resource.description}</p>

                <button className="btn-primary w-full text-sm py-2">
                  Download
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Case Studies */}
      <section className="bg-secondary-900 text-white section-padding">
        <div className="container-max">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Success Stories
            </h2>
            <p className="text-xl text-secondary-300 max-w-3xl mx-auto">
              Real results from campaigns that implemented our strategic methodologies
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {caseStudies.map((study, index) => (
              <div key={index} className="bg-secondary-800 p-8 rounded-xl">
                <div className="text-primary-400 font-semibold mb-2">{study.region}</div>
                <h3 className="text-xl font-bold mb-4">{study.title}</h3>
                <p className="text-secondary-300 mb-6">{study.description}</p>
                <div className="border-t border-secondary-700 pt-4">
                  <div className="text-primary-400 font-semibold">Outcome:</div>
                  <div className="text-white font-bold">{study.outcome}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="bg-primary-600 text-white section-padding">
        <div className="container-max">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Stay Ahead of the Competition
            </h2>
            <p className="text-xl mb-8 text-primary-100">
              Get exclusive access to new campaign resources, strategic insights, and
              political market intelligence delivered to your inbox.
            </p>

            <div className="bg-white p-6 rounded-xl">
              <form className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Your Name"
                    className="w-full px-4 py-3 rounded-lg border border-secondary-300 focus:outline-none focus:ring-2 focus:ring-primary-500 text-secondary-900"
                  />
                  <input
                    type="email"
                    placeholder="Your Email"
                    className="w-full px-4 py-3 rounded-lg border border-secondary-300 focus:outline-none focus:ring-2 focus:ring-primary-500 text-secondary-900"
                  />
                </div>
                <button type="submit" className="btn-primary w-full">
                  Get Strategic Insights
                </button>
              </form>
              <p className="text-secondary-600 text-sm mt-4">
                Join 500+ political leaders who receive our weekly campaign intelligence brief.
                Unsubscribe anytime.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-white section-padding">
        <div className="container-max text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-secondary-900 mb-6">
            Ready to Implement These Strategies?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto text-secondary-600">
            Don't just download resources—get personalized implementation support from
            Kenya's leading political strategists.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/services" className="btn-primary">
              Book Strategy Session
            </Link>
            <a href="mailto:kehosainstitute@gmail.com" className="btn-secondary">
              Request Custom Resources
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resources;